"use strict";

require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-prototype-of.js");
require("core-js/modules/es.object.set-prototype-of.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.reflect.to-string-tag.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.to-string.js");
var _react = _interopRequireDefault(require("react"));
var _Footer = require("./Footer");
require("./FooterFullStyle.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_1vid9mqq0a() {
  var path = "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_layout/FooterFull.tsx";
  var hash = "f756cfcf40aea6c575dda7bf2033674462747b52";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_layout/FooterFull.tsx",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 48
        },
        end: {
          line: 14,
          column: 3
        }
      },
      "1": {
        start: {
          line: 16,
          column: 28
        },
        end: {
          line: 18,
          column: 3
        }
      },
      "2": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 23
        }
      },
      "3": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 84
        }
      },
      "4": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 68
        }
      },
      "5": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 84
        }
      },
      "6": {
        start: {
          line: 31,
          column: 20
        },
        end: {
          line: 31,
          column: 86
        }
      },
      "7": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 35,
          column: 5
        }
      },
      "8": {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 34,
          column: 61
        }
      },
      "9": {
        start: {
          line: 39,
          column: 26
        },
        end: {
          line: 39,
          column: 36
        }
      },
      "10": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 242,
          column: 6
        }
      },
      "11": {
        start: {
          line: 245,
          column: 29
        },
        end: {
          line: 265,
          column: 3
        }
      },
      "12": {
        start: {
          line: 247,
          column: 4
        },
        end: {
          line: 263,
          column: 5
        }
      },
      "13": {
        start: {
          line: 248,
          column: 6
        },
        end: {
          line: 262,
          column: 8
        }
      },
      "14": {
        start: {
          line: 264,
          column: 4
        },
        end: {
          line: 264,
          column: 20
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 16,
            column: 28
          },
          end: {
            line: 16,
            column: 29
          }
        },
        loc: {
          start: {
            line: 16,
            column: 34
          },
          end: {
            line: 18,
            column: 3
          }
        },
        line: 16
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        },
        loc: {
          start: {
            line: 20,
            column: 29
          },
          end: {
            line: 25,
            column: 3
          }
        },
        line: 20
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        loc: {
          start: {
            line: 27,
            column: 32
          },
          end: {
            line: 36,
            column: 3
          }
        },
        line: 27
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        loc: {
          start: {
            line: 38,
            column: 18
          },
          end: {
            line: 243,
            column: 3
          }
        },
        line: 38
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 245,
            column: 29
          },
          end: {
            line: 245,
            column: 30
          }
        },
        loc: {
          start: {
            line: 245,
            column: 35
          },
          end: {
            line: 265,
            column: 3
          }
        },
        line: 245
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 22,
            column: 42
          },
          end: {
            line: 22,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 22,
            column: 42
          },
          end: {
            line: 22,
            column: 77
          }
        }, {
          start: {
            line: 22,
            column: 81
          },
          end: {
            line: 22,
            column: 83
          }
        }],
        line: 22
      },
      "1": {
        loc: {
          start: {
            line: 29,
            column: 42
          },
          end: {
            line: 29,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 29,
            column: 42
          },
          end: {
            line: 29,
            column: 77
          }
        }, {
          start: {
            line: 29,
            column: 81
          },
          end: {
            line: 29,
            column: 83
          }
        }],
        line: 29
      },
      "2": {
        loc: {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 35,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 35,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 32
      },
      "3": {
        loc: {
          start: {
            line: 45,
            column: 13
          },
          end: {
            line: 45,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 45,
            column: 34
          },
          end: {
            line: 45,
            column: 46
          }
        }, {
          start: {
            line: 45,
            column: 49
          },
          end: {
            line: 45,
            column: 51
          }
        }],
        line: 45
      },
      "4": {
        loc: {
          start: {
            line: 247,
            column: 4
          },
          end: {
            line: 263,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 247,
            column: 4
          },
          end: {
            line: 263,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 247
      },
      "5": {
        loc: {
          start: {
            line: 247,
            column: 8
          },
          end: {
            line: 247,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 247,
            column: 8
          },
          end: {
            line: 247,
            column: 37
          }
        }, {
          start: {
            line: 247,
            column: 41
          },
          end: {
            line: 247,
            column: 68
          }
        }],
        line: 247
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f756cfcf40aea6c575dda7bf2033674462747b52"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1vid9mqq0a = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1vid9mqq0a();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/** @deprecated */
var FullFooter = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(FullFooter, _React$Component);
  function FullFooter() {
    var _this;
    _classCallCheck(this, FullFooter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FullFooter, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "boundForceUpdate", (cov_1vid9mqq0a().s[1]++, function () {
      cov_1vid9mqq0a().f[0]++;
      cov_1vid9mqq0a().s[2]++;
      _this.forceUpdate();
    }));
    _defineProperty(_assertThisInitialized(_this), "showPhoenixLegal", (cov_1vid9mqq0a().s[11]++, function () {
      cov_1vid9mqq0a().f[4]++;
      cov_1vid9mqq0a().s[12]++;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((cov_1vid9mqq0a().b[5][0]++, typeof window !== 'undefined') && (cov_1vid9mqq0a().b[5][1]++, window.showPhxTest)) {
        cov_1vid9mqq0a().b[4][0]++;
        cov_1vid9mqq0a().s[13]++;
        return /*#__PURE__*/_react["default"].createElement("section", {
          className: "test-phx phx-legal less-padding"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-xs-12 text-x-small"
        }, /*#__PURE__*/_react["default"].createElement("p", null, "1 in 3 Sellers: Based on analysis of people who request an offer from Opendoor within 60 days of listing their home, May-October 2017."), /*#__PURE__*/_react["default"].createElement("p", null, "#1 Home Buyer: Based on volume of homes purchased in the Phoenix metro area."), /*#__PURE__*/_react["default"].createElement("p", null, "Top Rated Experience: Based on Net Promoter Score of customers who sold their home to Opendoor, Dec 2016 - October 2017.")));
      } else {
        cov_1vid9mqq0a().b[4][1]++;
      }
      cov_1vid9mqq0a().s[14]++;
      return /*#__PURE__*/_react["default"].createElement("span", null);
    }));
    return _this;
  }
  _createClass(FullFooter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_1vid9mqq0a().f[1]++;
      cov_1vid9mqq0a().s[3]++;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      window.optimizelyCallbacks = (cov_1vid9mqq0a().b[0][0]++, window.optimizelyCallbacks) || (cov_1vid9mqq0a().b[0][1]++, []);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      cov_1vid9mqq0a().s[4]++;
      window.optimizelyCallbacks.push(this.boundForceUpdate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_1vid9mqq0a().f[2]++;
      cov_1vid9mqq0a().s[5]++;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      window.optimizelyCallbacks = (cov_1vid9mqq0a().b[1][0]++, window.optimizelyCallbacks) || (cov_1vid9mqq0a().b[1][1]++, []);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var indexOf = (cov_1vid9mqq0a().s[6]++, window.optimizelyCallbacks.indexOf(this.boundForceUpdate));
      cov_1vid9mqq0a().s[7]++;
      if (indexOf !== -1) {
        cov_1vid9mqq0a().b[2][0]++;
        cov_1vid9mqq0a().s[8]++;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.optimizelyCallbacks.splice(indexOf, 1);
      } else {
        cov_1vid9mqq0a().b[2][1]++;
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_1vid9mqq0a().f[3]++;
      var _ref = (cov_1vid9mqq0a().s[9]++, this.props),
        topBorder = _ref.topBorder;
      cov_1vid9mqq0a().s[10]++;
      return /*#__PURE__*/_react["default"].createElement("footer", {
        className: "od-full-footer market-footer"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (topBorder === true ? (cov_1vid9mqq0a().b[3][0]++, 'top-border') : (cov_1vid9mqq0a().b[3][1]++, '')) + ' regular-container footer-container'
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row footer-top"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-12 col-sm-12 col-md-3"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "/"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: "https://imgdrop.imgix.net/logo-opendoor.svg",
        alt: "Opendoor",
        height: 25,
        className: "opendoor-logo"
      })), /*#__PURE__*/_react["default"].createElement("p", {
        className: "text-small text-muted hidden-sm-down"
      }, /*#__PURE__*/_react["default"].createElement(_Footer.Copyright, null)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "app-links"
      }, /*#__PURE__*/_react["default"].createElement("p", null, "Get the app"), /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://play.google.com/store/apps/details?id=com.opendoor.buyerapp&hl=en",
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        alt: "Download the Opendoor app on Android",
        src: "https://imgdrop.imgix.net/android-logo.svg",
        height: 12
      }), /*#__PURE__*/_react["default"].createElement("span", null, "Download for Android")), /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://itunes.apple.com/us/app/opendoor-homes-all-day-open/id1143708068?mt=8",
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        alt: "Download the Opendoor app on iOS",
        src: "https://imgdrop.imgix.net/apple-logo.svg",
        height: 12
      }), /*#__PURE__*/_react["default"].createElement("span", null, "Download for iOS")))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-12 col-sm-4 col-md-3"
      }, /*#__PURE__*/_react["default"].createElement("h6", {
        className: "text-medium medium-margin-bottom"
      }, "Services"), /*#__PURE__*/_react["default"].createElement("ul", {
        className: "sitemap"
      }, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "/"
      }, "Sell your home")), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "/w/homes"
      }, "Buy a home")), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "/trade-in"
      }, "Trade-in")), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "/w/how-it-works"
      }, "How it works")), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "/w/home-value"
      }, "Home value")))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-4 col-md-3 hidden-xs-down"
      }, /*#__PURE__*/_react["default"].createElement("h6", {
        className: "text-medium medium-margin-bottom"
      }, "About"), /*#__PURE__*/_react["default"].createElement("ul", {
        className: "sitemap"
      }, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "/w/about"
      }, "Who we are")), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "/w/contact-us"
      }, "Contact us")), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "/jobs"
      }, "Jobs")), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "/w/faq"
      }, "FAQ")), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "/w/resources"
      }, "Resources")))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-12 col-sm-4 col-md-3 hidden-xs-down"
      }, /*#__PURE__*/_react["default"].createElement("h6", {
        className: "text-medium medium-margin-bottom"
      }, "Customers"), /*#__PURE__*/_react["default"].createElement("ul", {
        className: "sitemap"
      }, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "/"
      }, "For home sellers")), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "/w/homes"
      }, "For home buyers")), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "/w/agents"
      }, "For real estate agents")), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "/w/reviews"
      }, "Reviews")), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "/w/stories"
      }, "Stories"))))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "row footer-bottom"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-12 col-md-3"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: "https://imgdrop.imgix.net/3c3b55d2bafb409fa42c8b33fd43c9d2.png",
        alt: "Equal housing opportunity",
        width: 45
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-12 col-md-5"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "/w/terms",
        className: "text-small"
      }, "Terms of Service"), ' · ', /*#__PURE__*/_react["default"].createElement("a", {
        href: "/w/privacy",
        className: "text-small"
      }, "Privacy policy"), ' · ', /*#__PURE__*/_react["default"].createElement("a", {
        href: "/privacyrequest",
        className: "text-small"
      }, "Do Not Sell My Info"), ' · ', /*#__PURE__*/_react["default"].createElement("a", {
        href: "/safety",
        className: "text-small"
      }, "Trust & Safety")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-12 col-md-1 hidden-sm-down"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-12 col-md-3 social-links"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://www.facebook.com/OpendoorHQ",
        target: "_blank",
        className: "social-link",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: "https://imgdrop.imgix.net/facebook-icon.svg",
        alt: "Opendoor on Facebook",
        width: 20
      })), /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://twitter.com/Opendoor",
        target: "_blank",
        className: "social-link",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: "https://imgdrop.imgix.net/twitter-icon.svg",
        alt: "Opendoor on Twitter",
        width: 20
      })), /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://www.linkedin.com/company/opendoor-com",
        target: "_blank",
        className: "social-link",
        rel: "noreferrer"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: "https://imgdrop.imgix.net/linkedin-icon.svg",
        alt: "Opendoor on LinkedIn",
        width: 20
      })), /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://www.instagram.com/opendoor/",
        target: "_blank",
        className: "social-link",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: "https://imgdrop.imgix.net/instagram-icon.svg",
        alt: "Opendoor on Instagram",
        width: 20
      })), /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://www.pinterest.com/opendoorhq/",
        target: "_blank",
        className: "social-link",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: "https://imgdrop.imgix.net/pinterest-icon.svg",
        alt: "Opendoor on Pinterest",
        width: 20
      }))))), this.showPhoenixLegal());
    }
  }]);
  return FullFooter;
}((_react["default"].Component));
_defineProperty(FullFooter, "defaultProps", (cov_1vid9mqq0a().s[0]++, {
  topBorder: true
}));